import { useState, memo } from "react";
import { useTranslation } from "react-i18next";
// UI component
import LinkerWithA from "../../../components/LinkerWithA";
// Util
import { setSortingHeader } from "../../../utils/sorting.util";

const TableHead = ({ columns, handleSorting, stickyStyle = {} }) => {
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const { t } = useTranslation();

  const handleSortingChange = (e, accessor) => {
    const sortOrder =
      accessor === sortField && order === "desc" ? "asc" : "desc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
    setSortingHeader(e);
  };

  return (
    <>
      <thead style={stickyStyle}>
        <tr>
          <th>#</th>
          {columns.map(({ label, accessor, sortable }) => {
            const cl = sortable
              ? sortField === accessor && order === "asc"
                ? "is-asc"
                : sortField === accessor && order === "desc"
                ? "is-desc"
                : "default"
              : "";
            return (
              <th key={accessor}>
                <LinkerWithA
                  label={t(label)}
                  className={`text-decoration-none ${cl}`}
                  key={accessor}
                  onClick={
                    sortable ? (e) => handleSortingChange(e, accessor) : null
                  }
                />
              </th>
            );
          })}
        </tr>
      </thead>
    </>
  );
};

export default memo(TableHead);
